import Logo from './assets/logo.svg';

export const header = (
  <a
    href="https://www.unimed.coop.br/site/"
    target="_blank"
    rel="noreferrer noopened"
  >
    <div
      className="sc-iqHYGH ieNPiA rsc-header"
      style={{
        background: '#00965d',
        height: '53px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
      }}
    >
      <img
        src={Logo}
        alt="UNIMED"
        style={{
          width: '100px',

          paddingLeft: '18px',
        }}
      />
    </div>
  </a>
);
